// Coordenadas de fallback (Obelisco, CABA) para cuando el browser no puede
// entregar la geolocalizacion: permiso denegado, API no disponible o timeout.
// Sin coords el login no puede generar el QR, asi que se usa este default.
// TODO ISO 27001: migrar a env vars cuando exista la pipeline.
export const DEFAULT_COORDS = {
    lat:
        Number(
            typeof process !== "undefined" && process.env?.REACT_APP_DEFAULT_LAT
        ) || -34.603684,
    lng:
        Number(
            typeof process !== "undefined" && process.env?.REACT_APP_DEFAULT_LNG
        ) || -58.381559,
};

// Timeout maximo de espera de la geolocalizacion antes de caer al default.
export const GEOLOCATION_TIMEOUT_MS = 10000;
